jQuery(document).ready(function( $ ) {

$('#headerSearch, #hero-search-input').on('blur keyup', function(){
	inputField = $(this);
	tmpval = inputField.val();
	nskCheckIfInputIsEmpty(tmpval, inputField);
});

$('#headerSearch ~ .btn.reset, #hero-search-input ~ .btn.reset').on('click', function(){
	inputField = $(this).siblings('input');
	setTimeout(function() {
		inputField.val('');
		tmpval = inputField.val();
		nskCheckIfInputIsEmpty(tmpval, inputField);
	}, 500);
});

$(document).on('ready', function() {
	if ($('#headerSearch').length) {
		inputField = $('#headerSearch');
		tmpval = inputField.val();
		nskCheckIfInputIsEmpty(tmpval, inputField);
	}
});

function nskCheckIfInputIsEmpty(tmpval, inputField) {
	if(tmpval == '') {
		$(inputField).addClass('empty');
		$(inputField).removeClass('not-empty');
	} else {
		$(inputField).addClass('not-empty');
		$(inputField).removeClass('empty');
	}
}


});